import { Controller } from "@hotwired/stimulus"

// Loads the selected AIRAC version's GeoJSON into the source textarea, then hands
// off to the shared pipeline: geojson-live-preview#input -> "changed" ->
// custom-map-layer#redrawLayer. Page-specific glue only — no map logic here, so the
// general map/preview controllers stay reusable and untouched.
export default class extends Controller {
  static targets = ["source"]
  static values = { url: String }

  async load(event) {
    const cycle = event.target.value
    if (!cycle) return

    let text
    try {
      const response = await fetch(`${this.urlValue}?airac_cycle=${encodeURIComponent(cycle)}`)
      if (!response.ok) return
      text = await response.text()
    } catch (_e) {
      return // leave the textarea untouched on failure, like the other controllers
    }

    this.sourceTarget.value = text
    this.sourceTarget.dispatchEvent(new Event("input")) // triggers geojson-live-preview#input
  }
}
